module.exports = __webpack_public_path__ + "static/media/UploadModeIcon.4e8dcff0.svg";